export const TEACHER_DASHBOARD = '/teacher/dashboard' as const
